import { render } from "./areaGoods.vue?vue&type=template&id=91e42784&scoped=true&ts=true"
import script from "./areaGoods.vue?vue&type=script&lang=ts"
export * from "./areaGoods.vue?vue&type=script&lang=ts"

import "./areaGoods.vue?vue&type=style&index=0&id=91e42784&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e42784"]])

export default __exports__